import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppHeader from "../../components/layout/AppHeader";
import AppSider from "../../components/layout/AppSider";
import { SidebarProvider } from "../../components/layout/SidebarContext";
import { writeStoredLastPath } from "../navigation";

const AppShell = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        writeStoredLastPath(location.pathname);
    }, [location.pathname]);

    return (
        <div className="app-shell">
            <SidebarProvider>
                <AppSider />
                <div className="app-shell__main">
                    <AppHeader />
                    <div className="app-shell__content">
                        <main className="app-shell__content-panel">{children}</main>
                    </div>
                </div>
            </SidebarProvider>
        </div>
    );
};

export default AppShell;
